import ListItems from "./ListarInfo";
import { useLocation } from "react-router-dom";

function Sintomas() {
	const { state } = useLocation();
	return ListItems("sintoma", state);
}

export default Sintomas;
